module.exports = __webpack_public_path__ + "img/heapsAndMaps.b2ab20f6.svg";